import React from "react";

import { ReactComponent as BuildingIcon } from "../../../assets/images/empresarial/building.svg";
import { ReactComponent as TrophyIcon } from "../../../assets/images/empresarial/trophy.svg";
import { ReactComponent as PinIcon } from "../../../assets/images/empresarial/pin.svg";
import { ReactComponent as ExplosionIcon } from "../../../assets/images/empresarial/explosion.svg";
import { ReactComponent as CautionIcon } from "../../../assets/images/empresarial/caution.svg";
import { ReactComponent as TheftIcon } from "../../../assets/images/empresarial/theft.svg";
import { ReactComponent as StrikeIcon } from "../../../assets/images/empresarial/strike.svg";
import { ReactComponent as BuglarIcon } from "../../../assets/images/empresarial/burglar.svg";

export const InsuranceAdvantageList = [
  {
    id: 1,
    icon: BuildingIcon,
    title: "MEI e pequenas empresas",
    description:
      "Ideal para o Microempreendedor  Individual e pequenos negócios, oferece segurança financeira a um preço mais acessível.",
  },
  {
    id: 2,
    icon: TrophyIcon,
    title: "Vantagens",
    description:
      "Com parcelas a partir de 40 reais por mês, cuide das suas conquistas com coberturas  que apoiam o seu negócio diante de situações inesperadas.",
  },
  {
    id: 3,
    icon: PinIcon,
    title: "Assistência 24h",
    description:
      "Inclui serviços emergenciais, como chaveiro e eletricista, para resolver os imprevistos do dia a dia.",
  },
];

export const InsuranceCoverageList = [
  {
    id: 1,
    icon: ExplosionIcon,
    title: "Incêndio, queda de raio e explosão",
    description:
      "Cobre danos à empresa nesses casos, desde que ocorram dentro do terreno ou prédio onde estão os bens segurados, com sinais claros do que aconteceu.",
  },
  {
    id: 2,
    icon: CautionIcon,
    title: "Danos elétricos",
    description: (
      <>
        Cobertura para danos e perdas de bens segurados, por falhas na rede
        elétrica, como curto-circuito, superaquecimento e variações anormais de
        tensão. Vale também para danos gerados pela queda de raio fora do
        terreno.
      </>
    ),
  },
  {
    id: 3,
    icon: TheftIcon,
    title: "Roubo de bens",
    description: (
      <>
        Em caso de roubo ou furto de máquinas, equipamentos, instalações e
        matérias-primas essenciais para o funcionamento do negócio, a
        indenização será paga de acordo com o previsto na apólice .
      </>
    ),
  },
  {
    id: 4,
    icon: StrikeIcon,
    title: "Dias de paralisação",
    description: (
      <>
        O seu negócio sofreu com a interrupção total ou parcial das atividades
        por mais de 5 dias? O pagamento das contas de água e luz estão
        garantidos, caso a paralisação seja causada por incêndio, raio ou
        explosão.
      </>
    ),
  },
  {
    id: 5,
    icon: BuglarIcon,
    title: "Equipamentos",
    description: (
      <>
        A cobertura vale para acidentes de causa externa, como batidas de
        veículos durante o transporte do equipamento, queda de raio, entre
        outras situações previstas na apólice do seguro. Indeniza, até o valor
        máximo contratado, os prejuízos aos equipamentos da empresa.
      </>
    ),
  },
];

export const InsurancefaqList = [
  {
    title: "O que o seguro cobre?",
    body: (
      <>
        <p>
          O seguro Fácil Empresarial Empreendedor possui as seguintes coberturas
          fixas:
        </p>

        <ul style={{ paddingLeft: "20px" }}>
          <li>Incêndio, queda de raio e explosão</li>
          <li>Diárias de Paralisação</li>
          <li>Roubo ou Furto</li>
          <li>Danos Elétricos</li>
          <li>Equipamentos</li>
        </ul>
      </>
    ),
  },
  {
    title:
      "É possível contratar o Seguro Empresarial se a empresa funcionar dentro da residência?",
    body: (
      <>
        Sim! Se a sua empresa funciona no seu lar, você pode contratar o Seguro
        Empresarial. O seguro vai cuidar do local, de acordo com as coberturas e
        limites de valores contratados, que estão na apólice e nas Condições
        Gerais.
      </>
    ),
  },
  {
    title: "Qual é o número de telefone para acionar o seguro?",
    body: <>Assistência e Sinistros - 0800 274 1000</>,
  },
  {
    title: "Quais são as formas de pagamento que o seguro oferece?",
    body: (
      <>
        O pagamento é feito somente por débito em conta da Caixa. Mas, se o
        débito não for realizado, podemos gerar um boleto para cobrança.
      </>
    ),
  },
  {
    title: "Quais são as exigências para a renovação automática da apólice?",
    body: (
      <>
        Para a renovação automática da apólice, é necessário que a pessoa
        segurada, ao preencher a proposta, declare por essa escolha e opte pelo
        pagamento via débito em conta Caixa. Além disso, na data da renovação, o
        cliente deve possuir saldo suficiente em sua conta corrente informada,
        para que o valor do seguro seja descontado.
      </>
    ),
  },
  {
    title: "Qual é o prazo para análise do pedido de indenização (sinistro)?",
    body: (
      <>
        A partir do recebimento de todos os documentos, a seguradora possui até
        30 dias corridos para analisar o pedido e apresentar a decisão final.
      </>
    ),
  },
  {
    title:
      "Não recebi o e-mail com a lista de documentos necessários para a análise do pedido, como faço?",
    body: (
      <>
        <p>
          Verifique a lixeira ou a caixa de spam do seu e-mail. Se não
          encontrar, entre em contato com a gente pelos seguintes canais de
          atendimento
        </p>
        <br />
        <p>
          <strong>Pelo chat - disponível neste site</strong>
          <br />
          De segunda a sexta, das 8h às 21h. Sábados, domingos e feriados, das
          9h às 17h.
        </p>
        <br />
        <p>
          <strong>Telefone 0800 274 1000</strong>
          <br />
          De segunda a sexta, das 8h às 21h, exceto feriados nacionais.
        </p>
      </>
    ),
  },
  {
    title:
      "O pedido de indenização foi aprovado, quando o pagamento será liberado?",
    body: (
      <>
        O valor será depositado em até 7 dias úteis, a partir da data de
        conclusão da análise.
      </>
    ),
  },
  {
    title: "Não concordo com a decisão da seguradora, posso recorrer? ",
    body: (
      <>
        Sim! Você pode pedir a revisão da análise do pedido. Para isso, deverá
        elaborar uma declaração com os motivos de não concordar com a decisão e
        enviar pra gente pelos mesmos canais de envio da documentação básica.
      </>
    ),
  },
  {
    title: "Quais os serviços oferecidos pela Assistência Dia & Noite?",
    body: (
      <>
        A Assistência Dia & Noite oferece serviços emergenciais em momentos de
        sinistro e indicação e envio de profissionais para pequenos reparos,
        como chaveiro por perda, roubo ou quebra das chaves, chaveiro por roubo
        ou furto do imóvel segurado, serviço de segurança e vigilância,
        hidráulica, eletricista, vidraceiro, transporte de ambulância, entre
        outros.
      </>
    ),
  },
  {
    title: "Quais os serviços oferecidos pela Assistência Dia & Noite?",
    body: (
      <>
        A Assistência Dia & Noite oferece serviços emergenciais em momentos de
        sinistro e indicação e envio de profissionais para pequenos reparos,
        como chaveiro por perda, roubo ou quebra das chaves, chaveiro por roubo
        ou furto do imóvel segurado, serviço de segurança e vigilância,
        hidráulica, eletricista, vidraceiro, transporte de ambulância, entre
        outros.
      </>
    ),
  },
  {
    title:
      "O seguro reembolsa serviços de assistência, como chaveiro, encanador e eletricista, contratados de forma particular?",
    body: (
      <>
        Apenas se a execução do serviço for comunicada antes e autorizada pela
        nossa equipe.
      </>
    ),
  },
  {
    title:
      "Como são as comissões de venda e as participações societárias dos intermediários para o seguro?",
    body: (
      <>
        Nos termos da Resolução CNSP nº 382/2020, a Caixa Seguradora informa que
        a CAIXA, por meio de sua subsidiária integral Caixa Seguridade
        Participações S.A., detém participação societária direta sobre a CNP
        Seguros Holding Brasil S.A., no percentual de 48,25%. A CNP Seguros
        Holding Brasil S.A. remunera seus intermediários em até 35% pela
        comercialização do seu Seguro Empresarial, de acordo com o canal de
        venda.
      </>
    ),
  },
];

export const InsuranceDocumentList = [
  {
    id: 1,
    label: "Condições Gerais Seguro Fácil Empresarial Empreendedor - 2025",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Empresarial/CondicoesGerais/Condicoes-Gerais-Seguro-Facil-Empresarial-Empreendedor-2025.pdf",
  },
  {
    id: 2,
    label: "Condições Gerais Seguro Empresarial - 2023",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Empresarial/CondicoesGerais/Condicoes-Gerais-Seguro-Empresarial-2023.pdf",
  },
  {
    id: 3,
    label: "Condições Gerais Seguro Empresarial - 2021",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Empresarial/CondicoesGerais/Condicoes-Gerais-Seguro-Empresarial-2021.pdf",
  },
  {
    id: 4,
    label: "Manual de Assistência - 2025",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Empresarial/Manuais/Manual-de-Assistencia-2025.pdf",
  },
];
